export default __webpack_public_path__ + "static/media/Beard_1_C4.f492595c.svg";